<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Oficinas Reuniões Treinamentos"
            description="Gerencie oficinas, reuniões e treinamentos"
            url="/dashboard"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-2271"
            pageIdentifier="oficinas-treinamentos"
            :enableBadgeModalInformacao="
              Number($store.state.permissoesRaw?.oficinas_treinamentos_ajuda || 0) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.oficinas_treinamentos_ajuda || 0
            "
            keyAjudaModalInformacao="oficinas_treinamentos_ajuda"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <span
                v-if="$store.getters.getQuantidadeAjuda(item.key) > 0"
                class="item-badge"
              >
                {{ $store.getters.getQuantidadeAjuda(item.key) }}
              </span>

              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img
                v-else-if="item.imagem !== ''"
                :src="item.imagem !== '' ? item.imagem : ''"
                alt=""
              />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  name: 'OficinasTreinamentos',
  metaInfo: {
    title: 'Oficinas Reuniões Treinamentos',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.oficinas_treinamentos
      ) {
        return this.$store.state.permissoes.oficinas_treinamentos
          .filter(item => item?.key !== 'ficha_atividade_coletiva'  && item?.key !== 'oficinas_treinamentos_guia_apresentacao'  && item?.key !== 'oficinas_treinamentos_guia')
          .sort((a, b) => a.ordem - b.ordem)
      }

      return []
    }
  },
  data() {
    return {}
  },
}
</script>

<style></style>
